const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: "",
          unit: "",
          afterFix: "년",
          lastLabel: true,
          useAll: true,
        },
      },
      {
        component: "search-month",
        label: "월",
        value: "month",
        query: { y_m: "month" },
        options: {
          default: "",
          useAll: true,
          lastLabel: true,
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-select",
        label: "구분",
        value: "type",
        query: { s_s: "select" },
        options: {
          default: "전체",
          items: ["전체", "크레인", "압력용기", "컨베이어", "국소배기장치", "전단기", "산업용로봇"],
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "설치일", "구분", "최근 안전검사일", "차기 안전검사일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "자체 관리번호",
        key: "body.subInfo.자체관리번호",
      },
      {
        name: "설치일",
        key: "body.subInfo.설치일",
      },
      {
        name: "합격번호",
        key: "body.subInfo.합격번호",
      },
      {
        name: "최근 안전검사일",
        key: "body.subInfo.최근안전검사일",
      },
      {
        name: "차기 안전검사일",
        key: "body.subInfo.차기안전검사일",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 사업장명
      case 1:
        return func.getContent(value).공장명; // 공장명
      case 2:
        return func.getContent(value).작업내용; // 작업내용
      case 3:
        return func.getContent(value).업체명; // 업체명
      case 4:
        if (func.getContent(value).작업기간.sDate || func.getContent(value).작업기간.sDate) return `${func.getContent(value).작업기간.sDate} ~ ${func.getContent(value).작업기간.eDate}`; // 작업기간
        else return "";
      case 5:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 6:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
